import React from 'react';
import LoadingCell from '../../../../ui/table/cells/loadingCell/loadingCell';

import './chipsCell.scss';

const ChipsCell = (props) => {
  if (props.rowType === 'groupHeader') {
    return null;
  }

  if (props.dataItem[props.field] === undefined && props.treelist) return <td />;
  if (props.dataItem[props.field] === undefined) return <LoadingCell />;

  let title = '';

  let chips = props.dataItem[props.field]
    ? props.dataItem[props.field].map((cv, i) => {
      if (i > 0)
        title += ', ';
      title += cv.name;

        return (
          <div className="chips" key={i}>
            {cv.name}
          </div>
        );
      })
    : 'none';

  return (
    <td>
        <div className="chips-cell" title={props.useTooltip ? title : ''}>
          {chips}
        </div>
    </td>
  );
};

export default ChipsCell;
